import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import '../../../styles/variables.css';
import '../../../styles/components/header.css';
import './Adminlogin.css';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import {firebase} from '../../../firebase/firebase';
import {withRouter, Link} from 'react-router-dom';
import {ShowNotification} from '../../../components/HandleNotifications';
import {NotificationContainer} from 'react-notifications';

class AdminLogin extends Component {

    state = {
        email: '',
        password: '',
        message: '',
        showPassword:false,
        showMessage: false,
        error: null
    };

    componentDidMount(){
        window.scrollTo(0,0)
    }
    
    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name] : value});
    };
    handleSubmit = (e) => {
        e.preventDefault();
        const {email, password} = this.state;
        firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
                if(user.user.emailVerified) {
                    firebase.auth().currentUser.getIdTokenResult()
                    .then((idTokenResult) => {
                        if(idTokenResult.claims.typeuser === 'adminUser'){
                            window.location.reload(true);
                        }else {
                            ShowNotification('error', 'Este apartado esta restringido por favor evita sanciones en la plataforma.', 'Usuario Incorrecto...');
                            firebase.auth().signOut();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                }else {
                    firebase.auth().signOut();
                    this.setState({ error: "Verifica tu correo", 
                    message: 'Es necesario que verifiques tu cuenta de correo electrónico, ve a tu bandeja de entrada y da click en el enlace que te hemos enviado.',
                    showMessage: true});
                    ShowNotification('error', this.state.error, 'Verifica tu cuenta...');
                }
            }).catch((error) => {
                let errorCode = error.code;
                if (errorCode === 'auth/invalid-email' || errorCode === 'auth/wrong-password') {
                    this.setState({ error: "Correo o contraseña invalida", 
                    message: 'El correo o contraseña que ingresaste es incorrecto, por favor verifica e intenta de nuevo',
                showMessage: true});
                } else if (errorCode === 'auth/user-not-found') {
                    this.setState({ error: "No se encontro usuario", 
                    message: 'No encontramos a ningun usuario registrado con este correo, si aun no tienes cuenta primero regístrate.',
                    showMessage:true });
                } else {
                    this.setState({ error: error });
                }
                ShowNotification('error', 'Hubo un error intentalo mas tarde', 'Algo salio mal...');
            });
    };
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    render(){       
        return(
            <div className="container a-login-back">
                <Row><Header admin={true}/></Row>
                <Row>
                    <Col className="login-left m-none p-none display-none" xs={12} sm={5} md={5} lg={5} xl={5}>
                    </Col>
                    <Col className="form-side" xs={12} sm={7} md={7} lg={7} xl={7}>
                        <p className="login-text">UDLAP Administradores.</p>
                        <p className="login-title">Por favor inicia sesión para administrar las vacantes.</p>
                        <label className="labels-l" htmlFor="email">Correo electrónico</label>
                        <input className="inputs" required="" type="email" name="email" onChange={this.handleInputChange}/>
                        <label className="labels-l" htmlFor="password">Contraseña</label>
                        <input className="inputs" required="" type={this.state.showPassword ? "text" : "password"} 
                        name="password" onChange={this.handleInputChange}/>
                        <div className="toggle-password-container-su">
                            <input type="checkbox" className='toggle-password' 
                            onClick={this.togglePassword} id="togglePassword"/>
                            <label className="toggle-password-label-su text-black" htmlFor="togglePassword">
                                Mostrar contraseña
                            </label>
                        </div>
                        {this.state.showMessage ? <p className="error-message">{this.state.message}</p> : null }
                        <button type="button m-t-e" onClick={this.handleSubmit} className="account-create mx-auto">Entrar</button>
                        <Link className="sign-up-link" to="/">Volver al inicio</Link>
                    </Col>
                </Row>
                <Row><Footer/></Row>
                <NotificationContainer />
            </div>
        )
    }


}
export default withRouter(AdminLogin);